import { Component, OnInit } from '@angular/core';
import { NgbDropdownModule, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { VioTablesModule } from 'vio-tables';
import { TABLE_CONFIG, TABLE_HEADER } from '../../../../node_modules/vio-tables/lib/Interfaces/commonInterfaces';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ConfigurationSettingComponent } from '../configuration-setting/configuration-setting.component';
import { CommonFunctionService } from '../../services/common-function.service';
import { ApiRequestsService } from '../../services/api-requests.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-configuration-list',
  standalone: true,
  imports: [NgbModule, NgbDropdownModule, VioTablesModule, CommonModule, FormsModule],
  templateUrl: './configuration-list.component.html',
  styleUrl: './configuration-list.component.scss'
})
export class ConfigurationListComponent implements OnInit {

  paraTableConfig: TABLE_CONFIG = {
    displayFormat: 'table',
    isSortable: true,
    isCheckBox: false,
    // "cellContextMenu": true,
    headerContextMenu: true,
    condition: false,
    displayBtnDiv: true,
    exporttoexcel: true,
    isButtonHover: true,
    formSearchBtnAt: 'start',
    cssClass: 'vio-table-bordered',

    headerContextMenuList: [
      {
        label: 'Hide Column',
        action: 'hidecolumn',
      },
      {
        label: 'Display Hidden Columns',
        action: 'displayhiddencols',
      },
      {
        label: 'Freeze Column(s)',
        action: 'freezecolumn',
      },
      {
        label: 'Unfreeze Column',
        action: 'unfreeze',
      },
      {
        label: 'Aggregate',
        action: 'aggregate',
      },
      {
        label: 'Remove Aggregate',
        action: 'removeaggregate',
      },
    ],
    actionButtons: [
      {
        btnName: 'Edit',
        btnTitle: 'Edit',
        btnIcon: 'fa fa-pen',
        btnClass: 'btn-primary mt-1',
      },
      {
        btnName: 'Delete',
        btnTitle: ' Delete',
        btnIcon: 'fa fa-trash',
        btnClass: 'btn-primary mt-1',
      }
    ],
  };

  showConfigTable: boolean = true;

  paraTableHeader: TABLE_HEADER[] = [
    { key: 'ctName', display: 'Configuration Name', datatype: 'string' },
    { key: 'ctDescr', display: 'Description', datatype: 'string' },
    // { key: 'roleId', display: 'Role', datatype: 'string' },
  ]

  paraTableData: any[] = [

  ];

  constructor(private ngbModal: NgbModal, public common: CommonFunctionService, private apiRequest: ApiRequestsService, private toaster: ToastrService) { }

  getConfigurationsList = async () => {

    let { errorCode, errorDescription, Data } = await this.apiRequest.postAPICallWithPromise('messageconfig/getConfigurations')

    if (errorCode == this.apiRequest.NO_ERROR) {
      this.paraTableData = Data;
    }
  }

  ngOnInit(): void {
    this.common.pageTitle = 'Manage Configuration';
    this.getConfigurationsList();
  }

  openConfigModal = async (data: any = {}) => {
    const ngbModelRef = this.ngbModal.open(ConfigurationSettingComponent, {
      windowClass: 'manage-config-modal',
      backdrop: 'static',
      //fullscreen: true,
      size: 'xl',
      backdropClass: 'manage-config-modal-backdrop',

    }); /****fullscreen: true, scrollable: true*/
    ngbModelRef.componentInstance.data = data;


    const result = await ngbModelRef.result;
    console.log('Result from modal', result)
    let { message, action } = result;
    if (message) {
      if (action == 'Success') {
        this.toaster.success(message)
      } else {
        this.toaster.error(message);
      }
    }
    await this.getConfigurationsList();
  };

  buttonClickEvent(event: any) {
    console.log('Button click event = ', event)
    if (event.buttonName.btnName == 'Edit') {
      this.openConfigModal(event.eventRow)
    }
  }

}
